export enum NotificationCategory {
    chatMessages = 'chatMessages',
    feedPost = 'feedPost',
    repliesToComments = 'repliesToComments',
    mentions = 'mentions',
}

export const CATEGORY_ORDER: NotificationCategory[] = [
    NotificationCategory.feedPost,
    NotificationCategory.chatMessages,
    NotificationCategory.repliesToComments,
    NotificationCategory.mentions,
]

export enum NotificationLevel {
    pushAndInApp = 'pushAndInApp',
    inAppOnly = 'inAppOnly',
    off = 'off',
}

export type NotificationCategoryLevels = Record<NotificationCategory, NotificationLevel>

export const DEFAULT_NOTIFICATION_CATEGORY_LEVELS: NotificationCategoryLevels = {
    [NotificationCategory.feedPost]: NotificationLevel.inAppOnly,
    [NotificationCategory.chatMessages]: NotificationLevel.pushAndInApp,
    [NotificationCategory.repliesToComments]: NotificationLevel.pushAndInApp,
    [NotificationCategory.mentions]: NotificationLevel.pushAndInApp,
}
